module.exports = __webpack_public_path__ + "img/_54A2259_t.381071bb.jpg";